import React, {useState, useEffect} from "react";

import AuthForm from "./AuthForm";
interface BookingAuthProps {
  onClose: () => void;
}

const BookingAuth: React.FC<BookingAuthProps> = ({onClose}) => {
  const [successAuth, setSuccessAuth] = useState(false);
  const handleClose = () => {
    onClose();
  }
  useEffect(() => {
    if (successAuth) {
      onClose();
    }
  }, [successAuth, onClose]);
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Backdrop - blurred background that covers the entire screen */}
      <div
        className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-all duration-300"
        // onClick={handleClose}
      />

      {/* Modal container - holds the AuthForm */}
      <div className="relative z-10 bg-gray-900 rounded-xl shadow-2xl w-[90%] max-w-[320px] sm:max-w-md mx-auto animate-in fade-in zoom-in-95 duration-300">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 sm:top-4 right-3 sm:right-4 text-gray-500 hover:text-gray-400 transition-colors"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Auth form */}
        <div className="p-4 sm:p-6">
          <AuthForm bookingMode={true} onSuccessAuth={setSuccessAuth} />
        </div>
      </div>
    </div>
  );
};

export default BookingAuth;